!(function () {
  "use strict";
  document.addEventListener("DOMContentLoaded", function () {
    (() => {
      const t = () => {
        document.documentElement.classList.add("intro-animation-has-done");
      };
      sessionStorage.getItem("intro-has-done")
        ? (t(), document.documentElement.classList.add("no-intro-animation"))
        : (document.documentElement.classList.add("intro-animation"),
          sessionStorage.setItem("intro-has-done", "true"),
          setTimeout(() => {
            t();
          }, 800));
    })(),
      (() => {
        const t = window.innerHeight,
          n = document.querySelector(".ry-intro__inner");
        let e;
        (e = navigator.userAgent.match(/iPhone|Android.+Mobile/)
          ? String(t) + "px"
          : "100%"),
          (n.style.height = e);
      })();
  });
})();
